<div class="container">
  <!-- Address Card -->
  <div class="card">
    <h2>Find your elected officials by address.</h2>
    <mat-divider></mat-divider>
    <form class="input" (ngSubmit)="onSubmit()" #form="ngForm" autocomplete="off">
      <mat-form-field>
        <mat-label>Enter address, congressional district or local union</mat-label>
        <input matInput name="searchValue" required [(ngModel)]="searchValue" autocomplete="off" />
        <mat-hint>e.g. "123 Main St", "TX-1", or "748"</mat-hint>
      </mat-form-field>
      <div [matTooltipDisabled]="searchValue" matTooltip="Please enter an address, congressional district, or local union to search for a scorecard">
        <button class="button" mat-raised-button color="primary" type="submit" [disabled]="!searchValue">
          Submit
        </button>
      </div>
      @if(isResetVisible){
        <button mat-raised-button color="primary" type="button" (click)="onReset()">
        Reset
      </button>
      }
    </form>
    <p class="bottom">
      For <i>"IBEW local"</i>, enter just the local number (e.g., 748). Search is limited to IBEW Inside Construction local unions.
    </p>
  </div>

  <!-- Congressman Dropdown Card -->
  <div class="card">
    <h2>Select a Member of Congress to view their voting record.</h2>
    <mat-divider></mat-divider>
    <div class="input">
      <mat-form-field>
        <mat-label>Select a member of Congress</mat-label>
        <input matInput #searchInput (input)="onSearchChange(searchInput.value)" [matAutocomplete]="auto" 
          [(ngModel)]="congressmanSearchValue" placeholder="Select or enter a congressman." />
        <mat-icon matSuffix (click)="trigger.openPanel()" style="cursor: pointer;">arrow_drop_down</mat-icon>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCongressman" (optionSelected)="onCongressmanSelected($event)">
          @for (congressman of filteredCongressmen; track congressman.description) {
            <mat-option [value]="congressman">
              {{ congressman.description }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <div matTooltip="Please select a congressman from the dropdown" [matTooltipDisabled]="!!selectedCongressman">
        <button mat-raised-button color="primary" class="button" (click)="onGetScorecard()" [disabled]="!selectedCongressman">
          Get Score Card
        </button>
      </div>
    </div>
    <p class="bottom" aria-hidden="true" style="visibility: hidden">
      placeholder for now, but we can add more instructions or info here if needed
    </p>
  </div>
</div>